/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { isError } from "@epic-mw/error-types";
import { useEffect } from "react";
import useSWRImmutable from "swr/immutable";

import { useAccountId } from "../account";
import { getApiPath } from "../utils";

const singUpCvent = async (eventId: string, target: string | null): Promise<string> => {
	try {
		const response = await fetch(`${getApiPath()}/cvent`, {
			method: "POST",
			body: JSON.stringify({
				target,
				eventId,
			}),
		});
		if (!response.ok) {
			return "";
		}
		return await response.text();
	} catch (err) {
		console.error("singUpCvent() failed to load", isError(err) && err.message);
		throw err;
	}
};

interface HookRes {
	isLoading: boolean;
	error: any;
}

export const useCventSignUp = (eventId: string, compliant: boolean, target: string | null): HookRes => {
	const accountId = useAccountId();
	const shouldFetch = Boolean(accountId && compliant && eventId);

	const { data, error } = useSWRImmutable(
		shouldFetch ? `cvent-${accountId}` : null,
		() => singUpCvent(eventId, target),
		{
			errorRetryCount: 0,
		},
	);

	useEffect(() => {
		if (data && compliant && !error) {
			const link = window.document.createElement("a");
			link.referrerPolicy = "no-referrer";
			link.rel = "noreferrer";
			link.href = data;
			link.click();
		}
	}, [compliant, data, error]);

	return {
		isLoading: Boolean(!data && !error && shouldFetch),
		error,
	};
};
